<template lang="pug">
    div.confirm-deliver-dialog(
        ref="ConfirmDeliverDialog"
    )
        el-dialog(
            :title="dialogData.title"
            :visible.sync="dialogData.show"
            :close-on-click-modal="false"
            width="600px"
            center
        )
            div(v-loading="loading")
                el-table(
                    :data="tableData"
                    style="width: 100%"
                )
                    el-table-column(
                        prop="date"
                        align="center"
                        label="商品信息"
                    )
                        template(slot-scope="scope")
                            div.goods-info
                                div.goods-img(v-show="scope.row.picUrl" :style="`background-image: url(${oss.PUBLIC.token.cdnHost}${scope.row.picUrl})`")
                                div.goods-spu
                                    div {{scope.row.spuName}}
                                    div {{scope.row.specInfo}}
                    el-table-column(
                        prop="name"
                        align="center"
                        label="数量"
                    )
                        template(slot-scope="scope")
                            div {{ scope.row.quantity === null ? '--' : `×${scope.row.quantity}` }}
                div.info
                    div.title 配送信息
                    div.info-item
                        div.label 配送方式：
                        div.content {{ orderData.deliveryWay }}
                    div.info-item
                        div.label 收货人：
                        div.content {{ orderData.consignee }} {{ orderData.consigneePhone }}
                    div.info-item
                        div.label 收货地址：
                        div.content {{ orderData.consigneeAddress }}
                div.info
                    div.title 发货方式
                    div.tips
                        i.el-icon-warning-outline(color="rgba(0,0,0,0.25)")
                        span 请仔细填写物流公司及物流单号，发货后72小时内仅支持做一次更正，逾期不可修改
                    div.form-container
                        el-form(
                            :model="formData"
                            :rules="rules"
                            ref="form"
                            label-width="94px"
                            style="width: 100%"
                        )
                            el-form-item(
                                label="物流公司："
                                prop="expressCompany"
                            )
                                el-select(
                                    v-model="formData.expressCompany"
                                    placeholder="请选择"
                                )
                                    el-option(
                                        v-for="item in expressCompanyList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    )
                            el-form-item(
                                label="物流单号："
                                prop="trackingNumber"
                            )
                                el-input(
                                    v-model.trim="formData.trackingNumber"
                                    placeholder="请输入真实有效的物流单号"
                                    show-word-limit
                                    maxlength="20"
                                    clearable
                                )
            div.footer
                el-button.button(
                    @click="handleCancel"
                    round
                ) 取消
                el-button.button(
                    :loading="btnLoading"
                    round
                    type="primary"
                    @click="handleSubmit"
                ) 确定
</template>

<script>
import oss from '@/utils/oss';
import DataList from '@/components/DataList.vue';
import { orderApis } from '@/api';
import { expressCompanyOpts } from '@/enum/common';

export default {
    name: 'GroupSelectGoodsDialog',
    components: {
        DataList,
    },
    props: {
        dialogData: {
            type: Object,
            default() {
                return {
                    title: '确认发货',
                    show: false,
                    orderData: {},
                };
            },
        },
    },
    data() {
        const validateNumber = (rule, value, callback) => {
            const reg = /^[a-zA-Z0-9]+$/;
            if (!reg.test(value)) {
                callback('请输入正确的物流单号，支持英文及数字');
            }
            callback();
        };
        return {
            oss,
            loading: false,
            btnLoading: false,
            orderData: {},
            tableData: [],
            expressCompanyList: expressCompanyOpts,
            formData: {
                expressCompany: '',
                trackingNumber: '',
            },
            rules: {
                expressCompany: [
                    {
                        required: true,
                        message: '请选择物流公司',
                        trigger: ['change', 'blur', 'submit'],
                    },
                ],
                trackingNumber: [
                    {
                        required: true,
                        message: '请填写物流单号',
                        trigger: ['change', 'blur', 'submit'],
                    },
                    {
                        trigger: ['change', 'blur', 'submit'],
                        validator: validateNumber,
                    },
                ],
            },
        };
    },
    watch: {
        dialogData: {
            deep: true,
            immediate: true,
            handler(val) {
                if (val) {
                    this.orderData = val.orderData;
                    this.tableData = this.orderData && this.orderData.orderItems ? this.orderData.orderItems : [];
                    this.formData = {
                        expressCompany: this.orderData.expressCompany,
                        trackingNumber: this.orderData.trackingNumber,
                    };
                }
            },
        },
    },
    methods: {
        async handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) { return; }
                try {
                    this.btnLoading = true;
                    const { code } = await orderApis.confirmDeliver({
                        ...this.formData,
                        id: this.orderData.id,
                    });
                    if (code === 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                        });
                        this.$emit('refresh');
                        this.dialogData.show = false;
                    }
                } catch (error) {
                    throw new Error(error);
                } finally {
                    this.btnLoading = false;
                }
            });
        },
        handleCancel() {
            this.dialogData.show = false;
        },
    },
};
</script>

<style lang="scss">
.confirm-deliver-dialog {
    .el-dialog .el-dialog__body {
        padding: 20px;
    }
    .el-table thead .cell {
        font-size: 12px;
        color: rgba(0,0,0,0.65);
    }
    .el-table th {
        padding: 0;
        background: #F9F9F9;
    }
    .el-table td .cell{
        padding: 8px 16px;
    }
}
</style>

<style lang="scss" scoped>
.confirm-deliver-dialog {
    .info {
        margin-top: 20px;
        .title {
            font-weight: 600;
            color: rgba(0,0,0,0.85);
            line-height: 22px;
        }
        .tips {
            font-size: 12px;
            color: rgba(0,0,0,0.45);
            line-height: 20px;
            margin-bottom: 20px;
            .el-icon-warning-outline {
                font-size: 14px;
                margin-right: 5px;
                position: relative;
                top: 1px;
            }
        }
        .info-item {
            display: flex;
            align-items: center;
            line-height: 22px;
            margin-top: 12px;
            .label {
                color: rgba(0,0,0,0.45);
            }
        }
    }
    .goods-info {
        display: flex;
        .goods-img {
            width: 48px;
            height: 48px;
            border-radius: 4px;
            background-repeat: no-repeat;
            background-size: 100%;
            margin-right: 16px;
        }
        .goods-spu {
            line-height: 20px;
            text-align: left;
        }
    }
    .footer {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        .el-button {
            width: 110px;
            padding: 8px 0 !important;
            height: 36px;
            border-radius: 18px;
            &:last-child {
                margin-left: 50px;
            }
        }
    }
}
</style>
